import { render, staticRenderFns } from "./huoDongDia.vue?vue&type=template&id=090f658c&scoped=true&"
import script from "./huoDongDia.vue?vue&type=script&lang=js&"
export * from "./huoDongDia.vue?vue&type=script&lang=js&"
import style0 from "./huoDongDia.vue?vue&type=style&index=0&id=090f658c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "090f658c",
  null
  
)

export default component.exports